import { Lock } from 'lucide-react'

export function ProtectionBadge() {
  return (
    <span
      className="inline-flex shrink-0 rounded-md bg-amber-500/15 p-1 text-amber-500"
      title="Geschützt"
      role="img"
      aria-label="Geschützt"
    >
      <Lock className="h-3.5 w-3.5" aria-hidden="true" />
    </span>
  )
}

export function ProtectionSubtitle() {
  return (
    <span className="block text-[11px] leading-4 text-amber-500">
      Geschützt: KI liest hier nicht
    </span>
  )
}
